'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateProps = getStateProps;

var _reactRedux = require('react-redux');

var _reduxField = require('redux-field');

var _utils = require('./utils');

var _FieldEl = require('./FieldEl');

var _FieldEl2 = _interopRequireDefault(_FieldEl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Expected Props
// ['description', id', 'initialValue', 'isRequired', 'name', 'prefix', 'type', 'validate']

// Only deal with the state needed to build Group and decide on View or Edit display.

// Add in the props we will pull out and use in Field.jsx component.
function getStateProps(state, props) {
  var fieldState = (0, _reduxField.getState)(state, props);
  return {
    isActive: (0, _utils.isActive)(fieldState, props),
    isEditable: (0, _utils.isEditable)(fieldState, props),
    showPreview: (0, _utils.showPreview)(fieldState, props),
    showEdit: (0, _utils.showEdit)(fieldState, props)
  };
}

exports.default = (0, _reactRedux.connect)(getStateProps)(_FieldEl2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/Field.js
// module id = 666
// module chunks = 0